// @flow
import axios from "axios";
// @ts-ignore
import {
  JsonApiDataStore,
  JsonApiDataStoreModel
} from "../../../node_modules/jsonapi-datastore";
// from "../../../node_modules/jsonapi-datastore/dist/jsonapi-datastore.js";
import { Serializable } from "../../models/serializable";
import Relationship from "@/models/relationship";

interface WithId {
  id: any;
}

export interface BaseRequestsInterface {
  with: any;
  fetchAll: any;
  fetch: any;
  fetchTransaction: any;
  fetchWith: any;
  create: any;
  edit: any;
  editWith: any;
  delete: any;
}

export function BaseRequests(
  endpoint: () => string,
  field: string,
  factory: () => any
) {
  const dataStore = new JsonApiDataStore();
  const endpointSafe = function() {
    const ep = endpoint();

    return ep;
  };

  return {
    with: (pathMap: Object) => ({
      ...BaseRequests(
        () => {
          let stubEndpoint = endpoint();
          Object.keys(pathMap).forEach(key => {
            // @ts-ignore
            stubEndpoint = stubEndpoint.replace(`:${key}`, pathMap[key]);
          });
          return stubEndpoint;
        },
        field,
        factory
      )
    }),
    fetchAll: (filters?: string, slash?: boolean): Promise<WithId[]> => {
      let tmpAndPoint = endpointSafe();
      if (filters && slash) {
        tmpAndPoint = `${tmpAndPoint}/${filters}`;
      } else if (filters) tmpAndPoint = `${tmpAndPoint}?${filters}`;
      return Promise.resolve().then(() =>
        axios.get(tmpAndPoint).then((response: any): any => {
          dataStore.reset();
          // META: TO REDO
          if (response.data.meta) {
            const { meta } = dataStore.syncWithMeta(response.data);
            dataStore.reset();
            dataStore.sync(response.data);
            return {
              data: dataStore
                .findAll(field)
                .map((items: any): WithId => factory().deserialize(items)),
              meta
            };
          }
          // response.data.meta
          //   ? dataStore.syncWithMeta(response.data)
          dataStore.sync(response.data);
          return dataStore
            .findAll(field)
            .map((items: any): WithId => factory().deserialize(items));
        })
      );
    },
    fetch: (id: number | string): Promise<WithId> =>
      Promise.resolve()
        .then(() => axios.get(`${endpointSafe()}/${id}`))
        .then((response: any): any => {
          dataStore.reset();
          dataStore.sync(response.data);
          const item = dataStore.find(field, id);
          return factory().deserialize(item);
        }),
    fetchTransaction: (id: number | string): Promise<WithId> =>
      Promise.resolve()
        .then(() => axios.get(`${endpointSafe()}/${id}`))
        .then((response: any): any => {
          dataStore.reset();
          dataStore.sync(response.data);
          const item = dataStore.find(field, response.data.data.attributes.id);
          return factory().deserialize(item);
        }),
    fetchWith: (): Promise<WithId> =>
      Promise.resolve()
        .then(() => axios.get(`${endpointSafe()}`))
        .then((response: any): any => {
          dataStore.reset();
          dataStore.sync(response.data);
          const item = dataStore.findAll(field);
          return factory().deserialize(item);
        }),
    create: (data: WithId, rel?: Relationship[]): any => {
      if (data) {
        const model = new JsonApiDataStoreModel(field);
        Object.entries(data).forEach(([key, value]) => {
          model.setAttribute(key, value);
        });
        if (rel && rel.length > 0)
          // relationship name?
          rel.forEach((relation: any) => {
            model.setRelationship(relation.relName, relation.models);
          });
        const serializedData = model.serialize();
        return axios.post(endpointSafe(), serializedData);
      }
      return axios.post(endpointSafe());
    },
    edit: (data: WithId): Promise<void> =>
      Promise.resolve()
        .then(() => axios.put(`${endpointSafe()}/${data.id}`, { data }))
        .then(() => {}),
    editWith: (data: WithId): Promise<void> =>
      Promise.resolve()
        .then(() => axios.put(`${endpointSafe()}`, { data }))
        .then(() => {}),
    delete: (id: number | string): Promise<void> =>
      Promise.resolve()
        .then(() => axios.delete(`${endpointSafe()}/${id}`))
        .then(() => {})
  };
}
